/* ============================================================================
   PAPI PAGE SHELL — nav auto-hide, menu drawer, scroll reveals
   ----------------------------------------------------------------------------
   Deliberately dependency-free. The homepage and the PDPs run GSAP + Lenis for
   their scroll work; these lighter pages do not need either, so they use an
   IntersectionObserver for reveals and native scroll for the nav.

   Pairs with papi-shell.css. Include it on any page carrying .nav and #menu.
   ========================================================================== */
(function () {
  'use strict';

  /* ---- menu drawer ---- */
  var toggle = document.querySelector('[data-menu-toggle]');
  var menu = document.getElementById('menu');

  function setMenu(open) {
    if (!menu || !toggle) return;
    menu.classList.toggle('on', open);
    toggle.setAttribute('aria-expanded', String(open));
    /* Lenis is not running on these pages, but check anyway so the same file
       works if one of them later adopts it. */
    if (window.__papiLenis) open ? window.__papiLenis.stop() : window.__papiLenis.start();
    else document.documentElement.style.overflow = open ? 'hidden' : '';
  }

  if (toggle && menu) {
    toggle.addEventListener('click', function () {
      setMenu(toggle.getAttribute('aria-expanded') !== 'true');
    });
    menu.addEventListener('click', function (e) {
      if (e.target.closest('a') || e.target.closest('[data-menu-close]')) setMenu(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.classList.contains('on')) setMenu(false);
    });
  }

  /* ---- nav auto-hide on scroll down, back on scroll up ---- */
  var nav = document.getElementById('nav');
  if (nav) {
    var lastY = window.scrollY || 0;
    window.addEventListener('scroll', function () {
      var cur = window.scrollY || 0;
      if (Math.abs(cur - lastY) < 6) return;            /* ignore jitter */
      nav.classList.toggle('nav--hidden', cur > lastY && cur > 140);
      lastY = cur;
    }, { passive: true });

    /* Nav text flips cream while any dark section is under it. Sections opt in
       with data-nav-dark rather than being listed here, so a page can add one
       without touching this file. */
    var darks = Array.prototype.slice.call(document.querySelectorAll('[data-nav-dark]'));
    if (darks.length) {
      var check = function () {
        var over = darks.some(function (d) {
          var r = d.getBoundingClientRect();
          return r.top < 60 && r.bottom > 60;
        });
        nav.classList.toggle('nav--overdark', over);
      };
      window.addEventListener('scroll', check, { passive: true });
      window.addEventListener('resize', check);
      check();
    }
  }

  /* ---- reveals ---- */
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var items = document.querySelectorAll('.reveal');
  if (reduce || !('IntersectionObserver' in window)) {
    items.forEach(function (el) { el.classList.add('in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('in');
        io.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -12% 0px' });
    items.forEach(function (el) { io.observe(el); });
  }


  /* ---- giant footer logo: eases down in scale as it comes into view ---- */
  /* Matches the homepage, which does the same thing with GSAP. These pages have
     no GSAP, so it is a plain rAF-throttled scroll handler. */
  var giant = document.querySelector('.giant img');
  if (giant && !reduce) {
    var section = giant.closest('.giant');
    var queued = false;
    var apply = function () {
      queued = false;
      var r = section.getBoundingClientRect();
      var vh = window.innerHeight || 800;
      /* 0 as the section's top reaches the bottom of the viewport, 1 once its
         own bottom does — the same span the GSAP version scrubs over. */
      var t = Math.min(1, Math.max(0, (vh - r.top) / Math.max(1, r.height + vh)));
      giant.style.transform = 'scale(' + (1.12 - 0.2 * t).toFixed(4) + ')';
    };
    var onScroll = function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(apply);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    apply();
  }


  /* ---- line-up cards: background clip is static until hover ---- */
  /* Same behaviour as the homepage, so the shop page's tiles are not just the
     same markup but the same interaction. */
  document.querySelectorAll('.pcard').forEach(function (card) {
    var vid = card.querySelector('.pcard__vid');
    if (!vid || reduce) return;
    card.addEventListener('pointerenter', function () { vid.play().catch(function () {}); });
    card.addEventListener('pointerleave', function () { vid.pause(); vid.load(); });
  });

  /* ---- infinite marquee rows (More Papi stockist strips) ---- */
  /* The row's children are duplicated once so the CSS translate can loop at
     -50% without a visible seam. Done in JS, not markup, so the page source
     lists each product exactly once. */
  document.querySelectorAll('[data-marquee]').forEach(function (row) {
    row.innerHTML += row.innerHTML;
    row.setAttribute('aria-hidden', 'false');
  });
})();
